import type { Collection } from '@/types/comic';

export const collections: Collection[] = [
  {
    id: 'col01',
    title: '九月新番 · 高甜恋爱特辑',
    subtitle: '本季最心跳的恋爱现场',
    description: '精选本季最让人脸红心跳的恋爱韩漫，从契约婚约到校园暗恋，一次看够心动名场面。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20romantic%20illustration%20of%20two%20hands%20almost%20touching%20under%20warm%20twilight%20petals%2C%20dreamy%20coral%20orange%20and%20teal%20glow%2C%20clean%20stylized%20background%2C%20soft%20cel%20shading%2C%20sweet%20romance%20feature%20banner%20art&width=900&height=520&seq=hanman-col-col01&orientation=landscape',
    comicIds: ['c01', 'c02', 'c04', 'c09', 'c12'],
  },
  {
    id: 'col02',
    title: '一口气看完 · 完结神作合集',
    subtitle: '不用等更新',
    description: '已经完结的高分韩漫合集，剧情完整、节奏爽快，适合周末一口气追到底。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20of%20a%20stack%20of%20completed%20comic%20volumes%20with%20a%20glowing%20mark%20of%20completion%2C%20warm%20orange%20and%20teal%20accent%20light%2C%20clean%20stylized%20background%2C%20soft%20cel%20shading%2C%20collection%20feature%20banner%20art&width=900&height=520&seq=hanman-col-col02&orientation=landscape',
    comicIds: ['c05', 'c11', 'c16'],
  },
  {
    id: 'col03',
    title: '烧脑悬疑 · 深夜推理特辑',
    subtitle: '越看越清醒',
    description: '反转不断的悬疑推理合集，迷雾、血月与匿名投票，小心看得睡不着。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20noir%20illustration%20of%20a%20magnifying%20glass%20over%20foggy%20city%20lights%2C%20moody%20teal%20mist%20and%20orange%20streetlamp%20glow%2C%20clean%20stylized%20background%2C%20soft%20cel%20shading%2C%20mystery%20thriller%20feature%20banner%20art&width=900&height=520&seq=hanman-col-col03&orientation=landscape',
    comicIds: ['c06', 'c10', 'c15'],
  },
  {
    id: 'col04',
    title: '异世界冒险 · 奇幻大赏',
    subtitle: '想象力的尽头',
    description: '从九霄剑歌到魔女杂货铺，4 部高分奇幻韩漫带你穿越一个又一个奇妙世界。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20epic%20fantasy%20illustration%20of%20floating%20islands%20and%20a%20magic%20portal%20glowing%20under%20sunset%2C%20vivid%20orange%20and%20deep%20teal%20palette%2C%20clean%20stylized%20background%2C%20soft%20cel%20shading%2C%20fantasy%20feature%20banner%20art&width=900&height=520&seq=hanman-col-col04&orientation=landscape',
    comicIds: ['c03', 'c08', 'c13', 'c10'],
  },
];